<template>
  <div class="wrapper">
    <div class="keywords-selector">
      <div class="d-flex align-center">
        <p class="keywords-selector__label">
          {{ $t("message.analytics.periodic.keywords.label") }}
        </p>
        <div
          v-if="keywords && keywords.length > 0"
          class="keywords-selector__chips"
        >
          <v-chip
            v-for="keyword in visibleKeywords"
            :key="keyword.id"
            outlined
            class="mr-2 my-1"
          >
            {{ keyword.keyword.name }}
            <v-icon
              class="ml-2 mr--1"
              color="grey"
              @click="deleteKeyword(keyword.id)"
            >
              icon-close
            </v-icon>
          </v-chip>
          <span
            v-if="keywords.length > maxVisibleKeywords"
            class="keywords-selector__more"
            >{{
              `+${keywords.length - maxVisibleKeywords} ${$t(
                "message.common.more"
              )}`
            }}</span
          >
        </div>
        <div
          v-else-if="keywords && keywords.length === 0"
          class="keywords-selector__empty"
        >
          <p>{{ $t("message.analytics.periodic.keywords.noKeywords") }}</p>
        </div>
      </div>

      <ui-button @click="setDialog('keywords', true)" color="primary" outlined>
        {{ $t("message.common.choose") }}
      </ui-button>
    </div>

    <ui-button
      @click="handleEditKeywords"
      icon="icon-edit"
      color="primary"
      class="my-2 mx-2"
    >
      {{ $t("message.common.edit") }}
    </ui-button>

    <KeywordsDialog
      :isOpen="dialog.keywords"
      :initially-selected-keywords="selectedKeywords"
      :report-type="selectedReportType"
      :isTableRoute="isTableRoute"
      @save="saveKeywords"
      @close="setDialog('keywords', false)"
    />
  </div>
</template>

<script>
import KeywordsDialog from "@/components/Analytics/Periodic/KeywordsDialog";

import { PERIODIC_REPORT_TYPE } from "@/enums/charts-type.enum";
import { gtmEvent__buttonClick } from "@/helpers/gtm-events";

export default {
  name: "PeriodicKeywordsSelector",
  components: { KeywordsDialog },
  data() {
    return {
      selectedKeywords: [],
      dialog: {
        keywords: false
      },
      maxVisibleKeywords: 3
    };
  },
  props: {
    keywords: {
      type: Array,
      required: true
    },
    selectedReportType: {
      type: Number,
      required: true,
      validator: val => Object.values(PERIODIC_REPORT_TYPE).includes(val)
    },
    isTableRoute: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    visibleKeywords() {
      return this.keywords && this.keywords.length <= this.maxVisibleKeywords
        ? [...this.keywords]
        : this.keywords.slice(0, this.maxVisibleKeywords);
    }
  },
  watch: {
    keywords(newVal) {
      if (!newVal || !Array.isArray(newVal)) return;

      if (newVal.length === 0) {
        this.selectedKeywords = [];
      } else {
        this.selectedKeywords = [...newVal];
      }
    }
  },
  methods: {
    saveKeywords(keywords) {
      this.selectedKeywords = keywords;
      this.$emit("save", keywords);
    },
    deleteKeyword(id) {
      const updatedKeywords = this.selectedKeywords.filter(
        keyword => keyword.id !== id
      );
      this.saveKeywords([...updatedKeywords]);
    },
    setDialog(type, state) {
      if (type in this.dialog) {
        this.dialog[type] = state;
      }
    },

    handleEditKeywords() {
      gtmEvent__buttonClick({ label: "add_new_keyword" });

      this.$router.push({
        name: "profile-company-in-web"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.keywords-selector {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: $spacing $spacing * 1.5;
  border-radius: 30px;
  background-color: $light-4;
  min-width: 861px;
  max-width: 861px;

  p {
    margin-bottom: 0;
    color: $text;
  }

  &__label {
    @include font-size(14px);
    margin-left: $spacing * 2;
    margin-right: $spacing * 1.75;
    font-weight: 500;
  }

  &__chips {
    max-width: 600px;
    overflow-x: hidden;
  }

  &__more {
    color: $text;
    @include font-size(12px);
    font-weight: 400;
    text-transform: lowercase;
    white-space: nowrap;
    margin-right: $spacing;
  }

  &__empty {
    margin-right: auto;

    p {
      @include font-size(12px);
      font-weight: 400;
      line-height: 21px;
    }
  }
}

.v-chip {
  @include vChip();
  white-space: pre-wrap;
}

.mr--1 {
  margin-right: $spacing * -0.75;
}
</style>
